export const verifyReservationBonvoyLookupService = async (
  roomNumber: string,
  lastName: string,
  marshaCode: string
) => {
  try {
    const response = await fetch('/internet-portal/v5/bonvoy-lookup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        roomNumber: roomNumber?.trim(),
        lastName: lastName?.trim(),
        propertyCode: marshaCode?.trim(),
      }),
    });

    const data = await response.json();

    // Handle non-200 status codes
    if (!response.ok) {
      throw new Error(data.message || `API Error: ${response.status}`);
    }

    return {
      success: true,
      ...data,
    };
  } catch (error) {
    console.error('Reservation verification error:', error);
    return {
      success: false,
      // error: error?.message,
      statusCode: 500,
      validReservation: false,
      memberStatus: 'unknown',
    };
  }
};

export const buildBonvoyLookupReturnUrl = (joinNowLink: string, prefillData: boolean): string => {
  const isAbsoluteUrl = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(joinNowLink);

  try {
    const joinNowUrl = new URL(
      joinNowLink,
      typeof window !== 'undefined' ? window.location.origin : 'https://www.marriott.com'
    );
    const returnToUrl = joinNowUrl.searchParams.get('returnToUrl');

    if (returnToUrl) {
      const returnToSearchSeparator = returnToUrl.includes('?') ? '&' : '?';
      joinNowUrl.searchParams.set('returnToUrl', `${returnToUrl}${returnToSearchSeparator}redirectToLSP=true`);
    } else {
      joinNowUrl.searchParams.set('redirectToLSP', 'true');
    }

    if (prefillData) {
      joinNowUrl.searchParams.set('isPrefillFlow', `true`);
    }

    return isAbsoluteUrl ? joinNowUrl.toString() : `${joinNowUrl.pathname}${joinNowUrl.search}${joinNowUrl.hash}`;
  } catch (error) {
    const fallbackSeparator = joinNowLink.includes('?') ? '&' : '?';
    const prefillQueryParam = prefillData ? `&isPrefillFlow=true` : '';
    return `${joinNowLink}${fallbackSeparator}redirectToLSP=true${prefillQueryParam}`;
  }
};
